import { render } from "./HomeDelivery.vue?vue&type=template&id=7b088336"
import script from "./HomeDelivery.vue?vue&type=script&lang=js"
export * from "./HomeDelivery.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__